import type { UiSkin } from "./skins";

export interface BrandNames {
    optivo: string;
    previoLine1: string;
    previoLine2: string;
    betterHotelLine1: string;
    betterHotelLine2: string;
}

/** A partner's wordmark the rail draws in place of `line1`, which still names it. */
export type BrandMark = "previo" | "better_hotel";

/** App-shell brand label. `line2` (e.g. "Optivo RMS") is null for skins with no PMS co-brand. */
export interface BrandLabel {
    line1: string;
    line2: string | null;
    /** Absent or null: `line1` is set as text. */
    mark?: BrandMark | null;
}

/** Resolves the app-shell brand label, split for two-line display, for the active skin. */
export function resolveBrandLabel(skin: UiSkin, names: BrandNames): BrandLabel {
    if (skin === "previo") return { line1: names.previoLine1, line2: names.previoLine2, mark: "previo" };
    if (skin === "better_hotel") return { line1: names.betterHotelLine1, line2: names.betterHotelLine2, mark: "better_hotel" };
    return { line1: names.optivo, line2: null, mark: null };
}

/** Flattens a BrandLabel to a single-line string, for contexts that can't wrap (tab title, tooltips). */
export function brandLabelToString(label: BrandLabel): string {
    return label.line2 ? `${label.line1} ${label.line2}` : label.line1;
}
